import { put } from 'redux-saga/effects'
import { actionTypes } from './accessory'

const { UPDATE_COUNTER_CLICKED_TIME } = actionTypes

export function* updateCounterClickedTimeTask(isCountable, everySixteenAccessories) {
  yield put({
    type: UPDATE_COUNTER_CLICKED_TIME, payload: { isCountable, everySixteenAccessories }
  })
}



// WEBPACK FOOTER //
// ./src/store/actions/accessory-async.js